// extracted by mini-css-extract-plugin
export default {"FirstSection":"NewBike_FirstSection__L7F0n","Left":"NewBike_Left__ARFvO","DescriptionField":"NewBike_DescriptionField__FnR18","ImgInput":"NewBike_ImgInput__UndrZ"};